import { cn } from '@/lib/utils';

import { SignalsSpinner } from './SignalsSpinner';

interface LoaderProps {
  className?: string;
}

const Loader = ({ className }: LoaderProps): JSX.Element => {
  return <SignalsSpinner size="sm" className={cn(className)} />;
};

export { Loader };
